<template>
	<detail :is-edit="true" />
</template>

<script>
	import Detail from './component/Detail'
	
	export default{
		name: 'EditGroup',
		components: {Detail}
	}
</script>